import React from "react";

const SectionAvailabilityInfo = ({ availability }) => {
  if (!availability || (!availability.startDate && !availability.endDate)) {
    return (
      <div className="section-availability-info">Availability Settings</div>
    );
  }

  const formatDate = (dateString) => {
    if (!dateString) return null;
    return new Date(dateString).toLocaleString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <div className="section-availability-info">
      {availability.startDate && (
        <div className="availability-date">
          <span className="availability-label">Available From:</span>
          <span className="availability-value">
            {formatDate(availability.startDate)}
          </span>
        </div>
      )}
      {availability.endDate && (
        <div className="availability-date">
          <span className="availability-label">Available Until:</span>
          <span className="availability-value">
            {formatDate(availability.endDate)}
          </span>
        </div>
      )}
    </div>
  );
};

export default SectionAvailabilityInfo;
